module.exports = __webpack_public_path__ + "static/media/SpeakerMax.a72c73de.svg";